export default [
    {
        label: 'Room & taxes only',
        id: 0,
    },
    {
        label: 'Room, tax & breakfast',
        id: 1,
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/authorized-charges.js